module.exports = __webpack_public_path__ + "img/Imperial Bank.0a08c46d.png";